function getPaymentType(payment)
{
  if(payment.cash_payment)
    return "cash";
  if(payment.cheque_payment)
    return "check";
  if(payment.cc_auto_payment)
    return "card"
}

export const PaymentWrapper = (data) =>
{
  const wrappedData = data.map(payment => {
    return {
      uuid: payment.payment_uuid,
      allow_edit_delete: payment.allow_edit_delete,
      amount_received: payment.amount_received,
      check_id: payment.check_id,
      customer_name: payment.customer_name,
      invoice_number: payment.invoice_number,
      payment_date: payment.payment_date,
      payment_type: payment.payment_type,
      received_by: payment.received_by,
      received_from: payment.received_from
    }
  });

  return wrappedData;
  // return wrappedData.filter(payment => payment.uuid !== undefined)
} 